import React from 'react';
import { useLocation } from 'react-router-dom';
import Store from '../../store/Store';
import { Logo } from './Logo';
import { UserMenu } from '../ui/UserMenu';
import WelcomeActions from "../features/WelcomeActions";
import ProviderHeaderNav from "../features/ProviderHeaderNav";

interface HeaderProps {
    logo?: boolean;
    title?: string;
    back?: boolean;
    step?: number;
    menu?: boolean;
    onBack?: () => void;
}

export const Header = (props: HeaderProps) => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';
    const isDashboard = location.pathname === '/dashboard';
    const isProvider = Store.mode === 'PROVIDER';
    return (
        <div
            id="header-div"
            className="w-full page-header top-0 z-[100]"
            style={{
                background: isLoginPage
                    ? '#ffffff'
                    : 'linear-gradient(to bottom, #ffffff, #D3E3F2)',
            }}
        >
            <div className="max-w-[1300px] m-auto px-[25px] md:px-[20px] md:py-[20px]">
                <div className="flex justify-between items-center w-full">
                    <div className="page-header-left">
                        <Logo onClick={() => Store.goHome()} />
                    </div>

                    <div className="page-header-body min-w-[800px]">
                        <div id="search-bar-menu">
                            {!isLoginPage && !isDashboard && !isProvider && (
                                <WelcomeActions
                                    top={false}
                                    dashboard={false}
                                    firstName={Store?.user?.firstName ?? ''}
                                    lastName={Store?.user?.lastName ?? ''}
                                />
                            )}
                            {isProvider && (
                               <ProviderHeaderNav />
                            )}
                        </div>
                    </div>

                    <div className="page-header-right">
                        <UserMenu />
                    </div>
                </div>

                {!isProvider && isDashboard && (
                    <DashboardWelcomeActionsWrapper>
                        <WelcomeActions
                            top={true}
                            dashboard={true}
                            firstName={Store?.user?.firstName ?? ''}
                            lastName={Store?.user?.lastName ?? ''}
                        />
                    </DashboardWelcomeActionsWrapper>
                )}
            </div>
        </div>
    );
};
const DashboardWelcomeActionsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<div className="flex flex-col items-center justify-center text-center mt-10 mb-6">
			{children}
		</div>
	);
};